import { api } from './client.js';

/** 원본 custom/make_token.php */
export interface IssuedToken {
  token: string;
  expiresAt: string;
  pcUrl: string;
  mobileUrl: string;
}

export interface FreepassToken {
  id: number;
  token: string;
  expiresAt: string;
  createdAt: string;
  alive: boolean;
}

export const tokensApi = {
  issueFreepass: () => api.post<IssuedToken>('/tokens/freepass', {}),
  listFreepass: () => api.get<FreepassToken[]>('/tokens/freepass'),
};
